module.exports = __webpack_public_path__ + "img/nav-script-on.4a9f2df7.png";